import { mobileValidator } from '@/common/utils/validate';
import { apiUserOtp } from '@/network/api/api';
import type { FormInstance } from 'antd';
import { Form, Input, Statistic, message } from 'antd';
import FormItem from 'antd/es/form/FormItem';

interface ContactInfoFormProps {
  formRef: FormInstance;
  onFinish: (title?: string) => void;
  canSendOPT: number;
  setCanSendOPT: (v: number) => void;
  countdownTime: number;
  setCountdownTime: (v: number) => void;
}

const ContactInfoForm: React.FC<ContactInfoFormProps> = ({
  formRef,
  onFinish,
  canSendOPT,
  setCanSendOPT,
  countdownTime,
  setCountdownTime,
}) => {
  // 发送验证码
  const send = () => {
    const phone = formRef.getFieldValue('contactPhone');
    if (!/^1[3-9]\d{9}$/.test(phone)) {
      message.warning('请输入正确手机号！');
      return;
    }
    if (canSendOPT != 1) {
      setCanSendOPT(1);
      setCountdownTime(Date.now() + 60 * 1000);
      apiUserOtp({ credential: phone, type: 2 });
    }
  };

  return (
    <Form layout="vertical" form={formRef} size="large" onFinish={onFinish}>
      <FormItem label="联系人" name="contactName" rules={[{ required: true }, { max: 10 }]}>
        <Input placeholder="请输入" />
      </FormItem>
      <FormItem label="联系手机" name="contactPhone" rules={[{ required: true }, mobileValidator()]}>
        <Input placeholder="请输入" type="tel" />
      </FormItem>
      <FormItem label="验证码" name="secret" rules={[{ required: true }, { len: 4 }]}>
        <Input
          placeholder="请输入"
          type="number"
          addonAfter={
            <div onClick={send}>
              <div style={{ display: canSendOPT == 1 ? 'none' : 'block' }}>
                {canSendOPT == 0 ? '发送验证码' : '重新发送'}
              </div>
              {canSendOPT == 1 ? (
                <Statistic.Countdown
                  value={countdownTime}
                  format="s"
                  onFinish={() => {
                    setCanSendOPT(2);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          }
        />
      </FormItem>
    </Form>
  );
};

export default ContactInfoForm;
